/**
 * entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class OrganizerGroup extends BaseModel {
    defaults() {
        return {
            // properties
            id: null,
            title: null,
            description: null,

            // virtual fields
            veranstalter_list: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    entityName() {
        return 'OrganizerGroup';
    }
}

export class OrganizerGroupCollection extends BaseCollection {
    options() {
        return {
            model: OrganizerGroup,
        };
    }

    entityName() {
        return 'OrganizerGroup';
    }
}
